import { Action } from 'redux';
import { UpdateNlpSettingSucceeded } from './AppActionTypes';

export const updateNlpSettingSucceeded = (): Action => ({
  type: UpdateNlpSettingSucceeded,
});
